// extracted by mini-css-extract-plugin
module.exports = {"history":"styles_history__zJHvG","record":"styles_record__0CHL5","pulse":"styles_pulse__iEEaX","jump":"styles_jump__UhKLd","wiggle":"styles_wiggle__xzDuB"};